import styled from '@emotion/styled';

const Card = styled.div`
  background-color: white;
  border-radius: 3px;
  box-shadow: 10px 10px 4px 0px rgba(0, 0, 0, 0.15);
  padding: 1rem;
  width: fit-content;
`;

const Centered = styled(Card)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: fit-content;
`;

const FloatingCard = Card;
FloatingCard.Centered = Centered;

export default FloatingCard;
